// extracted by css-extract-rspack-plugin
export default {"headingContainer":"_be5c1bf0","headingLink":"_f069e8f7","heading":"_b4d764d7","photoLink":"_f5b71dd3","firmWrapper":"_299c1afc","firmName":"_eb70d388"};